import { Injectable } from '@angular/core';
import { Query, gql } from 'apollo-angular';
import { LotNegotiationsResponse } from '../components/bids-and-offers/lots.model';

@Injectable({
  providedIn: 'root',
})
export class LotDetailsDesktopService extends Query<LotNegotiationsResponse> {
  document = gql`
    query DesktopLotDetailsQuery($id: String!) {
      lot(id: $id) {
        _id
        user_id
        lot_type
        indication
        commodity
        product_type
        currency
        volume_value
        units
        createdAt
        ship_begin
        ship_end
        destination
        delivery_type
        payment_term
        documentations {
          title
          value
        }
        specifications {
          title
          value
        }
        additional_info
        grade
        rules_to_govern
        weight_grade_to_govern
        price {
          ... on CashPrice {
            amount
          }
          ... on BasisPrice {
            month
            year
            product_code
            basisPoints
          }
        }
        packaging
        time_frame
        tolerance
        container_type
        delivery_option
        market_type
        status
        acceptedAt
        deletedAt
        origin
      }
      user {
        _id
      }
      negotiations {
        _id
        user_id
        lot_user_id
        lot_id
        lot_type
        createdAt
        counters {
          originator_id
          price_value {
            ... on CashPrice {
              amount
            }
            ... on BasisPrice {
              month
              year
              product_code
              basisPoints
            }
          }
          volume_value
          ship_begin
          ship_end
          created_at
        }
        lot_type
        commodity
        grade
        specifications {
          title
          value
        }
        currency
        volume_value_orig
        units
        ship_begin_orig
        ship_end_orig
        delivery_type
        container_type
        rules_to_govern
        delivery_option
        status
        origin
        lot_market_type
        product_type
        destination
        time_frame
        additional_info
        payment_term
        packaging
        tolerance
        weight_grade_to_govern
      }
    }
  `;
}
